<div matDialogTitle>Fel!</div>
<mat-dialog-content style="overflow: hidden">
  {{ data.text }}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button matDialogClose>Okej</button>
</mat-dialog-actions>